var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktopMd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 616,
    height: 501,
    viewBox: "0 0 616 501",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M263.57 127.022L229.887 146.443L150.395 100.32L185.288 80.9043L263.57 127.022Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.57 229.581L229.887 248.997L150.395 202.88L185.288 183.458L263.57 229.581Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.379 229.581L229.695 248.997L150.203 202.88L185.097 183.458L263.379 229.581Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.887 146.443V248.997",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.593 80.9043V183.458L150.43 202.846V100.286",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.57 126.685V229.244",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.533 184.673L124.849 204.095L45.3516 157.972L80.245 138.556L158.533 184.673Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.533 287.227L124.849 306.649L45.3516 260.531L80.245 241.109L158.533 287.227Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.336 287.227L124.658 306.649L45.1602 260.531L80.0536 241.109L158.336 287.227Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.848 204.095V306.648",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5502 138.556V241.109L45.3867 260.497V157.938",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.535 184.336V286.895",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478.309 178.298L444.63 197.72L365.133 151.602L400.026 132.181L478.309 178.298Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.309 280.858L444.63 300.279L365.133 254.156L400.026 234.74L478.309 280.858Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.117 280.858L444.439 300.279L364.941 254.156L399.835 234.74L478.117 280.858Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.629 197.72V300.279",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.331 132.181V234.74L365.168 254.122V151.568",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.309 177.967V280.52",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M582.672 236.163L548.988 255.584L469.496 209.461L504.39 190.045L582.672 236.163Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.672 338.722L548.988 358.138L469.496 312.02L504.39 292.599L582.672 338.722Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.478 338.722L548.795 358.138L469.297 312.02L504.19 292.599L582.478 338.722Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.984 255.584V358.138",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.685 190.045V292.599L469.527 311.986V209.427",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.672 235.825V338.385",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.953 108.938L324.631 128.359L404.129 82.2362L369.236 62.8203L290.953 108.938Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.953 211.497L324.631 230.913L404.129 184.796L369.236 165.374L290.953 211.497Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.145 211.497L324.823 230.913L404.32 184.796L369.427 165.374L291.145 211.497Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.633 128.359V230.913",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.934 62.8203V165.374L404.097 184.762V82.2025",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.953 108.601V211.16",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.836 62.7307L250.514 82.1466L330.012 36.0289L295.118 16.6074L216.836 62.7307Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.836 165.285L250.514 184.706L330.012 138.589L295.118 119.167L216.836 165.285Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.027 165.285L250.706 184.706L330.203 138.589L295.31 119.167L217.027 165.285Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.516 82.1465V184.706",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.816 16.6074V119.167L329.98 138.555V35.9952",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.836 62.3936V164.953",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.012 377.74L329.696 397.156L409.193 351.038L374.3 331.622L296.012 377.74Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.012 480.294L329.696 499.716L409.193 453.598L374.3 434.177L296.012 480.294Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.211 480.294L329.889 499.716L409.387 453.598L374.493 434.177L296.211 480.294Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.695 397.156V499.716",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.996 331.622V434.176L409.16 453.564V351.004",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.012 377.402V479.962",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.887 331.745L263.571 351.161L343.068 305.044L308.175 285.622L229.887 331.745Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.887 434.299L263.571 453.721L343.068 407.598L308.175 388.182L229.887 434.299Z",
    stroke: "#231F20",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.086 434.299L263.764 453.721L343.262 407.598L308.368 388.182L230.086 434.299Z",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.57 351.161V453.72",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.871 285.622V388.181L343.035 407.564V305.01",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.887 331.408V433.962",
    stroke: "white",
    strokeWidth: 1.50219,
    strokeMiterlimit: 10
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111.758 122.628L602.359 411.588",
    stroke: "white",
    strokeWidth: 9.01874,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.894 377.487L429.862 439.2L177.219 292.627L288.11 230.914L536.894 377.487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.7031 354.96L185.595 293.247",
    stroke: "white",
    strokeWidth: 9.01874,
    strokeMiterlimit: 10
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.127 271.652C255.551 271.208 254.375 270.87 253.081 270.504C255.506 266.549 257.864 262.718 260.311 258.723C259.062 258.408 258.027 258.149 256.817 257.845C259.085 253.626 261.307 249.496 263.625 245.181C262.213 244.973 261.048 244.804 259.467 244.568C264.491 237.473 267.411 229.54 270.438 221.18C273.594 229.445 276.346 237.451 281.516 244.562C279.935 244.787 278.731 244.956 277.291 245.164C279.603 249.446 281.82 253.541 284.132 257.823C282.99 258.11 281.966 258.369 280.605 258.712C283.046 262.678 285.421 266.538 287.862 270.51C286.529 270.881 285.347 271.208 283.806 271.635C286.895 276.04 289.865 280.266 293.117 284.902H273.662V300.205H267.327V285.009H247.742C251.022 280.333 253.993 276.097 257.127 271.635V271.652Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.75828,
    strokeMiterlimit: 10
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M387.903 310.259C386.839 309.955 386.04 309.73 385.168 309.482C386.811 306.81 388.398 304.216 390.058 301.521C389.214 301.308 388.51 301.133 387.695 300.931C389.225 298.078 390.727 295.288 392.297 292.368C391.34 292.227 390.553 292.109 389.484 291.957C392.882 287.158 394.851 281.796 396.899 276.147C399.031 281.734 400.894 287.147 404.387 291.957C403.318 292.109 402.503 292.227 401.529 292.362C403.093 295.254 404.59 298.028 406.154 300.919C405.383 301.116 404.691 301.291 403.769 301.521C405.417 304.205 407.026 306.81 408.675 309.499C407.774 309.753 406.975 309.972 405.929 310.259C408.016 313.235 410.025 316.093 412.225 319.227H399.071V329.573H394.789V319.3H381.551C383.767 316.138 385.776 313.275 387.897 310.259H387.903Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.75828,
    strokeMiterlimit: 10
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.274 384.807C439.21 384.503 438.412 384.278 437.539 384.03C439.182 381.358 440.769 378.764 442.429 376.069C441.585 375.856 440.881 375.681 440.066 375.479C441.596 372.626 443.098 369.835 444.668 366.916C443.711 366.775 442.924 366.657 441.855 366.505C445.253 361.706 447.222 356.344 449.27 350.695C451.402 356.282 453.265 361.694 456.758 366.505C455.69 366.657 454.874 366.775 453.9 366.91C455.464 369.802 456.961 372.575 458.525 375.467C457.754 375.664 457.062 375.839 456.14 376.069C457.788 378.753 459.397 381.358 461.046 384.047C460.145 384.3 459.347 384.52 458.3 384.807C460.387 387.783 462.396 390.641 464.596 393.775H451.442V404.121H447.16V393.848H433.922C436.139 390.686 438.147 387.822 440.268 384.807H440.274Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.75828,
    strokeMiterlimit: 10
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.352 281.076C232.557 280.57 231.218 280.187 229.75 279.771C232.512 275.27 235.19 270.904 237.981 266.358C236.558 265.998 235.382 265.705 234.003 265.356C236.586 260.557 239.112 255.848 241.756 250.937C240.147 250.7 238.819 250.503 237.019 250.239C242.741 242.16 246.06 233.13 249.509 223.61C253.104 233.017 256.232 242.137 262.123 250.233C260.322 250.492 258.95 250.683 257.307 250.92C259.94 255.792 262.466 260.462 265.099 265.334C263.799 265.66 262.629 265.958 261.088 266.347C263.867 270.864 266.573 275.259 269.352 279.782C267.833 280.204 266.489 280.575 264.733 281.065C268.25 286.078 271.631 290.894 275.333 296.171H253.183V313.595H245.97V296.295H223.668C227.404 290.972 230.785 286.151 234.352 281.065V281.076Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.75828,
    strokeMiterlimit: 10
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M355.911 286.556C354.116 286.05 352.777 285.668 351.308 285.251C354.071 280.75 356.749 276.384 359.54 271.838C358.116 271.478 356.94 271.186 355.562 270.837C358.144 266.038 360.67 261.329 363.315 256.417C361.706 256.181 360.378 255.984 358.577 255.719C364.299 247.64 367.619 238.61 371.068 229.091C374.663 238.498 377.791 247.618 383.681 255.714C381.881 255.973 380.508 256.164 378.865 256.4C381.498 261.272 384.025 265.942 386.658 270.814C385.358 271.141 384.188 271.439 382.646 271.827C385.426 276.345 388.132 280.739 390.911 285.262C389.392 285.684 388.047 286.056 386.292 286.545C389.808 291.558 393.19 296.374 396.892 301.651H374.741V319.076H367.529V301.775H345.227C348.962 296.453 352.344 291.631 355.911 286.545V286.556Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.75828,
    strokeMiterlimit: 10
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.208 400.644C410.413 400.138 409.074 399.755 407.605 399.339C410.368 394.838 413.046 390.472 415.836 385.926C414.413 385.566 413.237 385.274 411.859 384.925C414.441 380.126 416.967 375.417 419.612 370.505C418.002 370.269 416.675 370.072 414.874 369.807C420.596 361.728 423.916 352.698 427.364 343.179C430.96 352.586 434.088 361.706 439.978 369.802C438.178 370.06 436.805 370.252 435.162 370.488C437.795 375.36 440.321 380.03 442.955 384.902C441.655 385.229 440.485 385.527 438.943 385.915C441.722 390.433 444.429 394.827 447.208 399.35C445.689 399.772 444.344 400.144 442.589 400.633C446.105 405.646 449.486 410.462 453.189 415.739H431.038V433.164H423.826V415.863H401.523C405.259 410.541 408.641 405.719 412.208 400.633V400.644Z",
    fill: "white",
    stroke: "#477263",
    strokeWidth: 3.75828,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.896 85.9901L186.43 4L7 115.364L203.257 229.885",
    stroke: "white",
    strokeWidth: 6.76265,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M439.071 156.908L608.733 259.591L427.233 350.004L417.365 355.275L317.32 296.898",
    stroke: "white",
    strokeWidth: 6.76265,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M431.802 134.346L440.849 147.86V175.744L431.802 180.172L398.945 161.2V123.82V115.375L431.802 134.346Z",
    stroke: "white",
    strokeWidth: 6.01437,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M378.441 111.982L398.943 123.82",
    stroke: "white",
    strokeWidth: 6.01437,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M378.441 141.222L398.943 153.059",
    stroke: "white",
    strokeWidth: 6.01437,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M252.138 260.817C256.617 258.375 247.418 233.693 245.612 229.586C237.662 211.47 219.608 201.376 201.075 197.1C192.529 195.131 183.741 195.306 175.229 197.286C173.569 197.669 159.47 200.639 160.015 202.991C165.619 227.065 175.892 252.906 201.677 261.475C212.44 265.053 224.339 266.15 235.524 264.136C240.295 263.275 247.885 263.118 252.133 260.817H252.138Z",
    stroke: "white",
    strokeWidth: 6.01437,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopMd);
export default __webpack_public_path__ + "static/media/desktop-md.a4904e190ca4103e9bb6bd9714fdcba7.svg";
export { ForwardRef as ReactComponent };